/* Box Constants */

/**
 * Material thickness
 *
 * Standard cardboard thickness used for boxes is 1/16 inch => 0.0625 inch.
 * @type {number}
 */
export const MATERIAL_THICKNESS = 0.0625;
export const MATERIAL_THICKNESS_MAILER = 0.0625;
export const MATERIAL_THICKNESS_LITERATURE = 0.0625;
export const MATERIAL_THICKNESS_SHIPPING = 0.125;

/**
 * Pixels Per Inch
 *
 * Standard screen resolution is 96 pixels per inch.
 * @type {number}
 */
export const BASE_PPI = 96;
export const PPI = 70;
export const PPI_RATIO = PPI / BASE_PPI;

/**
 * Bleed
 *
 * We use 0.15625 inch which is 1.25 times the standard bleed.
 * @type {number}
 */
export const BLEED = 0.15625;

export const FLAP_GAP = MATERIAL_THICKNESS

export const GLUE_FLAP_WIDTH = 1.5

export const COLOR_KRAFT = '#BE9D67'
export const COLOR_WHITE = '#FFFFFF'
